import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a72d69ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/consultation_room.css?vue&type=style&index=0&id=a72d69ea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72d69ea",
  null
  
)

export default component.exports